/**
 * DrilldownTable - Table showing individual wells
 * @module wellRegistrationTotals/components/organisms/DrilldownPanel/DrilldownTable
 */

import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core";
import { DrilldownTableContainer } from "../../../styled";

/**
 * Single well row
 */
const WellRow = React.memo(({ well, idx }) => (
  <TableRow key={well.well_ndx || idx}>
    <TableCell style={{ whiteSpace: "nowrap" }}>
      {well.cuwcd_well_number || "-"}
    </TableCell>
    <TableCell>{well.contact_name || "-"}</TableCell>
    <TableCell>{well.address || "-"}</TableCell>
    <TableCell>{well.city || "-"}</TableCell>
    <TableCell>{well.zip || "-"}</TableCell>
    <TableCell>{well.aquifer_name || "-"}</TableCell>
    <TableCell align="right">
      {well.well_depth_ft ? `${well.well_depth_ft}'` : "-"}
    </TableCell>
    <TableCell>{well.primary_use || "-"}</TableCell>
    <TableCell>{well.well_status || "-"}</TableCell>
  </TableRow>
));

WellRow.displayName = "WellRow";

/**
 * Table showing individual wells for drilldown
 * @param {Object} props
 * @param {Array} props.wells - Array of well objects
 */
const DrilldownTable = React.memo(({ wells }) => (
  <DrilldownTableContainer component={Paper} variant="outlined">
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell style={{ whiteSpace: "nowrap" }}>Well #</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Address</TableCell>
          <TableCell>City</TableCell>
          <TableCell>Zip</TableCell>
          <TableCell>Aquifer</TableCell>
          <TableCell>Depth (ft)</TableCell>
          <TableCell>Use</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {wells.map((well, idx) => (
          <WellRow key={well.well_ndx || idx} well={well} idx={idx} />
        ))}
        {wells.length === 0 && (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No wells found for this period
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </DrilldownTableContainer>
));

DrilldownTable.displayName = "DrilldownTable";

export default DrilldownTable;
